var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1179"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1179"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34766",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};